var App = App || {};

App.TableOverflow = (function ($) {
    return {
        init: init
    };

    function init() {
        if (!_myComponentIsOnPage()) {
            return;
        }
        bindScrollEvent();
        checkWindowResize();
        checkSplitView();
    }

    function _myComponentIsOnPage() {
        return $('.table-overflow').length;
    }

    function checkWindowResize() {
        $(window).on('resize', function () {
            bindScrollEvent();
        });
    }

    function checkSplitView() {
        $(document).on('splitScreenEvent', function (event, isSplitView) {
            if (isSplitView) {
                bindScrollEvent(); 
            } else if ($('.tab-nav-FiguresTablesCss').hasClass('active')) {
                bindScrollEvent();
            } 
        });
        $(document).on('click', '.js-FiguresTables-tab-trigger', function () {
            bindScrollEvent();
        });
    }

    function bindScrollEvent() {
        var $tableOverflow = $('.table-overflow');

        $tableOverflow.each(function () {
            var $table = $(this);
            var clientWidth = $table.width();
            var scrollWidth = $table.prop('scrollWidth');

            var canHandleScroll = Math.floor(scrollWidth) > Math.floor(clientWidth) && !$table.data('scrollEventSet');
            if (canHandleScroll) {

                if ($table.closest('.abstract').length > 0) {
                    $table.addClass('abstract-background');
                }
                $table.addClass('overflowing');
                if ($table.scrollLeft() > 0) {
                    $table.addClass('scrolled-right');
                }
                $table.on('scroll', function () {
                    handleScroll($table);
                });
                $table.data('scrollEventSet', true);
            }
            else if (scrollWidth <= clientWidth && $table.data('scrollEventSet')) { // Remove overflowing
                $table.off('scroll');
                $table.removeData('scrollEventSet');
                $table.removeClass('overflowing');
                $table.removeClass('scrolled-right');
            }

        });

    }

    function handleScroll($table) {
        var clientWidth = $table.width();
        var scrollWidth = $table.prop('scrollWidth');
        var scrollLeft = $table.scrollLeft();
        var reachedRightmostSide = Math.ceil(scrollLeft + clientWidth) >= scrollWidth - 1;

        // Handle right gradient
        if (reachedRightmostSide) {
            $table.removeClass('overflowing');
        } else {
            $table.addClass('overflowing');
            $table.css('--right-value', `-${scrollLeft}px`);
        }

        // Handle left gradient
        if (scrollLeft > 0) {
            $table.addClass('scrolled-right');
            $table.css('--left-value', `${scrollLeft}px`);
        } else {
            $table.removeClass('scrolled-right');
        }
    }

})(jQuery);